import { useEffect, useRef } from 'react'

function useMouseParallax(strength = 20) {
  const ref = useRef(null)

  useEffect(() => {
    const node = ref.current
    if (!node) return

    let frame = null
    let targetX = 0
    let targetY = 0
    let currentX = 0
    let currentY = 0

    const handleMouseMove = (e) => {
      const rect = node.getBoundingClientRect()
      const relX = (e.clientX - rect.left) / rect.width - 0.5
      const relY = (e.clientY - rect.top) / rect.height - 0.5
      targetX = relX * strength
      targetY = relY * strength
    }

    const animate = () => {
      currentX += (targetX - currentX) * 0.08
      currentY += (targetY - currentY) * 0.08
      node.style.setProperty('--parallax-x', `${currentX}px`)
      node.style.setProperty('--parallax-y', `${currentY}px`)
      frame = requestAnimationFrame(animate)
    }

    node.addEventListener('mousemove', handleMouseMove)
    frame = requestAnimationFrame(animate)

    return () => {
      node.removeEventListener('mousemove', handleMouseMove)
      if (frame) cancelAnimationFrame(frame)
    }
  }, [strength])

  return ref
}

export default useMouseParallax
